var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CountPopup',{directives:[{name:"show",rawName:"v-show",value:(_vm.type == 0),expression:"type == 0"}]}),(_vm.type === 1 && _vm.countList)?_c('CountDownSmall',{attrs:{"count":_vm.countList,"state":_vm.state},on:{"close":_vm.onClose}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }